import * as React from 'react';
export const IcAward = (props: React.SVGProps<SVGSVGElement>): JSX.Element => (
  <svg
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M20 10a8 8 0 10-12.53 6.59L7 19.72a2 2 0 003.09 1.94L12 20.4l1.89 1.26A2 2 0 0015 22a2.002 2.002 0 001.98-2.31l-.45-3.13A8 8 0 0020 10zm-8 6a6 6 0 110-12 6 6 0 010 12zm2.49-7.16l-1.34-.2-.61-1.29a.59.59 0 00-1.08 0l-.61 1.29-1.34.2a.6.6 0 00-.34 1l1 1-.25 1.46a.61.61 0 00.89.63l1.19-.66 1.19.66a.631.631 0 00.64-.04.61.61 0 00.25-.59l-.24-1.43 1-1a.6.6 0 00-.34-1l-.01-.03z'
      fill='currentColor'
    />
  </svg>
);
